// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const classNames = (...args: any[]) => args.filter(Boolean).join(' ');
